import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { apiFetch, apiSearch } from '../modules/utility';

const apiBase = 'equipmentAssignment';
const listName = `${apiBase}s`;
const idField = `${apiBase}Id`;
const idsField = `${idField}s`;
const item = 'equipment assignment';
const onSuccessRedirectTo = `/equipmentAssignment/list`;

const search = (p = {}) => {
	const { callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			dispatch,
			callback,
		});
	};
};

const searchByEquipment = ({ equipmentId, callback }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.search`,
			params: {
				equipmentIds: [equipmentId],
				includePast: true,
			},
			dispatch,
			callback,
		});
	};
};

const get = ({ params = {}, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

const add = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.add`,
			listNameToUpdate: idsField,
			params,
			dispatch,
			savingMessage: `Updating ${item}...`,
			savedMessage: `${_.capitalize(item)} updated successfully. 
				Click continue to return to the ${item}s page.`,
			onSuccessRedirectTo,
			delay: 350,
			callback,
		});
	};
};

const update = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			savingMessage: `Updating ${item}...`,
			savedMessage: `${_.capitalize(item)} updated successfully. 
				Click continue to return to the ${item}s page.`,
			onSuccessRedirectTo,
			delay: 350,
			callback,
		});
	};
};

const end = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.remove`,
			params,
			dispatch,
			callback,
		});
	};
};

const mapStateToProps = (state, ownProps) => {
	const newState = {};

	const userId = ownProps[idField]
		? ownProps[idField]
		: _.get(ownProps, ['match', 'params', idField]);

	newState[apiBase] = _.get(state.maps, [apiBase, userId]);

	newState[listName] = [];
	if (state.lists[idsField]) {
		newState[listName] = _.map(state.lists[idsField], (id) => state.maps[apiBase][id]);
	}

	newState.locationMap = state.maps.location;
	newState.shiftMap = state.maps.shift;
	newState.equipmentMap = state.maps.equipment;
	return newState;
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			searchEquipmentAssignments: search,
			searchEquipmentAssignmentsByEquipment: searchByEquipment,
			getEquipmentAssignment: get,
			addEquipmentAssignment: add,
			updateEquipmentAssignment: update,
			endEquipmentAssignment: end,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
